import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_LANGUAGE_FIELD_ENABLE } from "@faire/web-api--source/indigofair/settings/HELP_CENTER_LANGUAGE_FIELD_ENABLE";

export function getSettingHelpCenterLanguageFieldEnabled(): boolean {
  return getSettingValueWithoutAssignment(
    HELP_CENTER_LANGUAGE_FIELD_ENABLE,
    false
  );
}
